<template lang="pug">
//- MEMO:
  - vgt関連の機能
  - 学割設定
  については、現在使用しておらずデザインの確認ができないため削除。
  使用を再開するタイミングで追加してください。
div
  .l-eventdtl
    .eventdtl-main
      img(:src="event.cover_image.ogp_1200.url" height="189" loading="lazy")
    .eventdtl-info
      a.c-btn-border(v-if="isMyNote" :href="`/n/${note.id}/edit`" target="_note_edit")
        | 編集する
      h1
        | {{ draftTxt }}{{ event.name }}
        .pr(v-if="event.paid_publicity")
          | Sponsored by {{ event.paid_publicity }}
      share(:twitterShareText="event.name" className="eventdtl-sns")

      dl.eventdtl-info-dl
        dt
          icon-calendar-svg
          strong 開催日時
        dd
          | {{ event.period }}
          template(v-if="event.entry")
            br
            a.v-google-calendar(:href="event.entry.google_calendar_url" target="_blank")
              img(v-lazy="require('~/assets/images/common/google-calendar.png')" width="20" height="20")
              | Googleカレンダーに登録する
        dt
          icon-place-svg
          strong 場所
        dd
          | {{ event.place }}
        dt
          icon-pay-svg
          strong 参加費
        client-only
          dd
            //- Premium限定イベント
            template(v-if="event.premium_only")
              div
                .price(v-html="priceTxt(event.premium_entry_fee)")
                .limited （Premium会員のみ参加可能）
              template(v-if="!$auth.loggedIn || $auth.user.status === 'free'")
                br
                .premium-link
                  nuxt-link(to="/setting/billing") ※Vook Premium(年額払い 1,665円/月)とは？
            //- キャリア限定イベント
            div(v-else-if="event.event_type === 'career'")
              .price(v-html="priceTxt(event.entry_fee)")
              .limited （Vookキャリアユーザーのみ参加可能）
            //- 通常イベント
            .price_table(v-else)
              strong
                | 通常価格
              .price(v-html="priceTxt(event.entry_fee)")
              template(v-if="event.premium_entry_fee != null")
                strong
                  | Premium会員
                .price(v-html="priceTxt(event.premium_entry_fee)")
                template(v-if="!$auth.loggedIn || $auth.user.status === 'free'")
                  .premium-link
                    nuxt-link(to="/setting/billing") ※Vook Premium(年額払い 1,665円/月)とは？

      .eventdtl-info-notice(v-if="event.drawing")
        | こちらのイベントの
        strong 応募結果
        | は後日連絡します。
        br
        | お申し込みいただいても参加できない可能性があることをご了承ください。
      .eventdtl-info-notice(v-if="event.event_type === 'career'")
        | Vookキャリアにご登録いただくと
        br.sp
        | 申し込み可能になります

    .eventdtl-speaker(v-if="event.creators.length > 0")
      .eventdtl-ttl ゲスト
      .speakers
        .speakers-item(v-for="creator in event.creators" :key="creator.id")
          .speakers-item-thumb
            img(v-lazy="creator.thumbnail.thumb_300.url" :alt="creator.name")
          .speakers-item-name
            span(v-if="creator.title")
              | {{ creator.title }}
            strong
              | {{ creator.name }}
          .speakers-item-description(v-html="getCreatorDescription(creator)")

    .eventdtl-ttl イベント内容
    .eventdtl-content
      rendered-markdown(:content="note.event_content")
      template(v-if="isShowPremiumPrompt")
        premium-registration
      share(:twitterShareText="event.name" className="eventdtl-sns")
    .eventdtl-btn
      template(v-if="event.drawing")
        .drawing(v-if="event.entry")
          dl.drawing-state
            dt 抽選結果：
            dd(:class="`is-${event.entry.drawing_state}`") {{ drawingState }}
          a.vo-btn.theme-primary.theme-large(v-if="event.entry.drawing_state === 'winning'" :href="`/events/${event.slug}`")
            | チケットを表示
          span.vo-btn.theme-closed.theme-large(v-else)
            | 抽選応募済み
        template(v-else-if="event.entryable")
          a.vo-btn.theme-primary.theme-large(:href="getUrl" @click="setEventCookies()")
            | {{ buttonName }}
          div(v-if="event.questant_url")
            span(style="font-size: 12px; color: red;") ※アンケートにご協力いただくとイベントに参加できます
        span.vo-btn.theme-closed.theme-large(v-else)
          | 受付は終了しました
      template(v-else)
        a.vo-btn.theme-primary.theme-large(v-if="event.entry" :href="`/events/${event.slug}`")
          | チケットを表示
        template(v-else-if="event.entryable")
          a.vo-btn.theme-primary.theme-large(:href="getUrl" @click="setEventCookies()")
            | {{ buttonName }}
          div(v-if="event.questant_url")
            span(style="font-size: 12px; color: red;") ※アンケートにご協力いただくとイベントに参加できます
        span.vo-btn.theme-closed.theme-large(v-else)
          | 受付は終了しました
      .notice(v-if="event.event_type === 'career'")
        | Vookキャリアにご登録いただくと
        br.sp
        | 申し込み可能になります

  .eventdtl-related
    .l-container.is-lg
      PickUpEvents(:events="pickUpEvents")
</template>
<script>
import RemainingLabel from '~/components/events/RemainingLabel'
import Share from '~/components/notes/Share'
import RenderedMarkdown from '~/components/RenderedMarkdown'
import Meta from '~/assets/mixins/meta'
import PickUpEvents from '~/components/PickUpEvents'
import RelatedPackages from '~/components/notes/RelatedPackages'
import LoglyCardStyleRelatedNotes from '~/components/LoglyCardStyleRelatedNotes'
import PremiumRegistration from '~/components/PremiumRegistration'
import IconCalendarSvg from '~/assets/images/svg/icon_calendar.svg?inline'
import IconPlaceSvg from '~/assets/images/svg/icon_place.svg?inline'
import IconPeopleSvg from '~/assets/images/svg/icon_people.svg?inline'
import IconPaySvg from '~/assets/images/svg/icon_pay.svg?inline'
import { simpleFormat } from '~/libs/common'

export default {
  components: {
    RemainingLabel,
    Share,
    RenderedMarkdown,
    PickUpEvents,
    RelatedPackages,
    LoglyCardStyleRelatedNotes,
    PremiumRegistration,
    IconCalendarSvg,
    IconPlaceSvg,
    IconPeopleSvg,
    IconPaySvg
  },
  mixins: [Meta],
  watchQuery: true,
  async asyncData({ params, $axios, query }) {
    const note = await $axios.$get(`/notes/${params.id}?t=${query.t}`)
    const { token } = await $axios.$get('/events/preview_token')
    const event = await $axios.$get(`/events/${note.event_id}?t=${token}`)
    const pickUpEvents = await $axios.$get('/events', {
      params: {
        count: 3
      }
    })
    return {
      meta: {
        title: event.name,
        description: note.summary,
        image: event.cover_image.ogp_1200.url
      },
      bodyAttrs: {
        class: 'notes-show header-fixed'
      },
      note,
      event,
      pickUpEvents
    }
  },
  computed: {
    drawingState() {
      let dState = ''
      switch (this.event.entry.drawing_state) {
        case 'result_pending':
          dState = '抽選待ち'
          break
        case 'winning':
          dState = '当選'
          break
        case 'unseated':
          dState = '落選'
          break
      }
      return dState
    },
    buttonName() {
      let bName = ''
      if (this.event.hold_format === 'webinar') {
        bName = 'ウェビナーに申し込む'
      } else if (this.event.event_type === 'school') {
        bName = 'ワークショップに申し込む'
      } else {
        bName = 'イベントに申し込む'
      }
      return bName
    },
    isMyNote() {
      return this.$auth.loggedIn && this.note.user_id === this.$auth.user.id
    },
    draftTxt() {
      return this.note.published ? '' : '下書き: '
    },
    priceTxt() {
      return (fee) => {
        if (fee) {
          return `${fee.toLocaleString()}円<div class="price-zei">(税込)</div>`
        }
        return '無料'
      }
    },
    isShowPremiumPrompt() {
      if (
        this.event.premium_only &&
        (!this.$auth.loggedIn || this.$auth.user.status === 'free')
      ) {
        return true
      }

      if (this.event.premium_entry_fee == null) {
        return false
      }

      if (this.event.entry_fee === this.event.premium_entry_fee) {
        return false
      }

      return !this.$auth.loggedIn || this.$auth.user.status === 'free'
    },
    getUrl() {
      if (!this.$auth.loggedIn && this.event.event_type === 'career') {
        return `${process.env.CAREER_URL}/sign_up`
      }
      if (!this.$auth.loggedIn) {
        this.$cookies.set('afterLoginURL', this.$route.fullPath)
        return '/users/sign_in'
      }
      if (
        this.$auth.loggedIn &&
        this.event.event_type === 'career' &&
        this.$auth.user.career_status !== 'completed'
      ) {
        return `${process.env.CAREER_URL}/registration`
      }
      if (this.event.questant_url) {
        return `${this.event.questant_url}?id=${this.$auth.user.id}`
      }
      return `/events/${this.event.slug}`
    }
  },
  methods: {
    getCreatorDescription(creator) {
      return simpleFormat(creator.description)
    },
    setEventCookies() {
      if (!this.$auth.loggedIn && this.event.event_type === 'career') {
        return this.$cookies.set('eventPath', `/events/${this.event.slug}`)
      }
      if (
        this.$auth.loggedIn &&
        this.event.event_type === 'career' &&
        this.$auth.user.career_status !== 'completed'
      ) {
        return this.$cookies.set('eventPath', `/events/${this.event.slug}`)
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .l-eventdtl {
    background: #fff;
    margin: 0 auto;
    @include media(pc) {
      width: 900px;
      padding: 0 $spacer_5;
    }
    @include media(sp) {
      padding: 0 $spacer_edge;
    }
    .eventdtl-sns {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 9px 0;
      background: $light_gray;
      border-radius: 5px;
      border: 1px solid #eee;
      h3 {
        padding: 5px 10px;
        line-height: 1;
        @include media(pc) {
          font-size: 14px;
        }
        @include media(sp) {
          font-size: 11px;
        }
      }
      ul {
        display: flex;
        padding: 5px;
      }
      li + li {
        padding-left: 10px;
      }
    }
    .eventdtl-ttl {
      background: #eee;
      font-weight: 500;
      font-size: 18px;
      @include media(pc) {
        padding: $spacer_edge $spacer_5;
        margin: 0 -#{$spacer_5};
      }
      @include media(sp) {
        padding: $spacer_edge;
        margin: 0 -#{$spacer_edge};
      }
    }
    .eventdtl-main {
      border-bottom: 1px solid $light_violet_border;
      @include media(pc) {
        margin: 0 -#{$spacer_5};
      }
      @include media(sp) {
        margin: 0 -#{$spacer_edge};
      }
      img {
        display: block;
        width: 100%;
      }
    }
    .eventdtl-info {
      @include media(pc) {
        padding: $spacer_5 0;
      }
      @include media(sp) {
        padding: $spacer_edge 0 $spacer_4;
      }
      .c-btn-border {
        margin: 40px 40px 0;

        @include media(sp) {
          margin: 20px 10px 0;
        }
      }
      h1 {
        font-size: 25px;
        font-weight: 400;
        margin-bottom: $spacer_edge;
        @include media(sp) {
          font-size: 18px;
        }
        .pr {
          margin-top: 20px;
          font-size: 10px;
          @include pr;
          @include media(pc) {
            font-size: 12px;
          }
        }
      }
      &-dl {
        display: grid;
        grid-template-columns: auto 1fr;
        row-gap: $spacer_2;
        align-items: flex-start;
        margin-top: $spacer_edge;
        line-height: 1.6;
        @include media(pc) {
          column-gap: $spacer_edge;
          font-size: 17px;
        }
        @include media(sp) {
          column-gap: $spacer_2;
          font-size: 14px;
        }
        dt {
          position: relative;
          padding: 1px 0 1px 30px;
          @include media(pc) {
            padding-left: 40px;
          }
          svg {
            position: absolute;
            top: 0;
            left: 0;
            margin-right: 10px;
            fill: none;
            stroke: $font_color_base;
            @include media(pc) {
              width: 30px;
              height: 30px;
            }
            @include media(sp) {
              width: 25px;
              height: 25px;
            }
          }
        }
        dd {
          padding: 1px;
          .v-google-calendar {
            margin-top: 8px;
          }
          .price_table {
            display: grid;
            grid-template-columns: auto 1fr;
            column-gap: 15px;
          }
          .price {
            display: inline-block;
            white-space: nowrap;
            &-zei {
              display: inline;
              padding-left: 3px;
              font-size: 0.8em;
              color: $font_color_light;
            }
          }
          .limited {
            display: inline-block;
            color: $red;
          }
          .premium-link {
            grid-column: 1/3;
            margin-top: 5px;
            a {
              display: inline-block;
              padding: 5px;
              border-radius: $radius;
              background: $light_violet;
              line-height: 1.5;
              text-decoration: none;
              color: $violet;
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
      &-notice {
        margin-top: $spacer_edge;
        @include alert_box;
      }
    }
    .eventdtl-speaker {
      .speakers {
        padding: $spacer_4 0 $spacer_5;
        &-item {
          display: grid;
          column-gap: $spacer_2;
          row-gap: 20px;
          @include media(pc) {
            grid-template-columns: 150px 1fr;
            padding: 0 $spacer_5;
            margin: 0 -#{$spacer_5};
          }
          @include media(sp) {
            grid-template-columns: 120px 1fr;
            align-items: center;
            padding: 0 $spacer_edge;
            margin: 0 -#{$spacer_edge};
          }
          & + .speakers-item {
            margin-top: $spacer_4;
            padding-top: $spacer_4;
            border-top: 1px solid $dark_violet_border;
          }
          &-thumb {
            @include media(pc) {
              grid-column: 1;
              grid-row: 1/3;
            }
            img {
              display: block;
              border-radius: 50%;
              aspect-ratio: 1/1;
              object-fit: cover;
              @include media(pc) {
                width: 150px;
                height: 150px;
              }
              @include media(sp) {
                width: 120px;
                height: 120px;
              }
            }
          }
          &-name {
            line-height: 1.6;
            @include media(pc) {
              grid-column: 2;
              grid-row: 1;
            }
            span {
              display: block;
              font-size: 10px;
              margin-bottom: 12px;
            }
            strong {
              display: block;
              font-size: 18px;
            }
          }
          &-description {
            @include media(pc) {
              grid-column: 2;
              grid-row: 2;
            }
            @include media(sp) {
              grid-column: 1/3;
            }
            p {
              line-height: 1.6;
              font-size: 14px;
            }
            p + p {
              margin-top: 10px;
            }
          }
        }
      }
      &-other {
        float: right;
        color: $font_color_light;
        background: $light_gray;
        padding: 5px 14px;
        border-radius: $radius;
        font-size: 12px;
      }
    }
    .eventdtl-content {
      @include media(pc) {
        padding-top: $spacer_5;
      }
      @include media(sp) {
        padding-top: $spacer_4;
      }
      .p_show-content-post {
        @include media(pc) {
          margin-bottom: $spacer_6;
        }
        @include media(sp) {
          margin-bottom: $spacer_4;
        }
        table {
          width: 100%;
          border-bottom: 1px solid #ddd;
          margin-bottom: 40px;
          th,
          td {
            border-top: 1px solid #ddd;
            vertical-align: top;
            @include media(sp) {
              display: block;
            }
          }
          th {
            white-space: nowrap;
            font-weight: bold;
            font-size: 0.8em;
            padding: 17px 30px 17px 0;
          }
          td {
            padding: 15px 0;
            font-size: 0.85em;
            @include media(sp) {
              border: none;
              padding-top: 0;
            }
            span {
              color: $font_color_light;
              font-size: 0.9em;
              display: block;
            }
            .video {
              margin-bottom: 0;
              margin-top: 10px;
            }
            .eventdtl-post-price {
              display: table;
              dl {
                display: table-row;
              }
              dt,
              dd {
                display: table-cell;
              }
              dt {
                padding-right: 20px;
              }
            }
          }
          & + h2 {
            margin-top: -30px;
            &::before {
              display: none;
            }
          }
        }
      }
    }
    .eventdtl-btn {
      position: sticky;
      bottom: 0;
      z-index: 10;
      background: #fff;
      border-top: 1px solid $dark_violet_border;
      text-align: center;
      @include media(pc) {
        width: calc(100% + #{$spacer_5} * 2);
        margin: $spacer_5 -#{$spacer_5} 0;
        padding: $spacer_edge $spacer_5;
      }
      @include media(sp) {
        width: calc(100% + #{$spacer_edge} * 2);
        margin: $spacer_edge -#{$spacer_edge} 0;
        padding: $spacer_2 $spacer_edge;
      }
      .drawing {
        @include media(pc) {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @include media(sp) {
          text-align: center;
        }
        &-state {
          display: flex;
          align-items: center;
          white-space: nowrap;
          @include media(pc) {
            margin-right: $spacer_edge;
          }
          @include media(sp) {
            justify-content: center;
            margin-bottom: 10px;
          }
          dt {
            margin-right: 5px;
            font-weight: bold;
            @include media(pc) {
              font-size: 1.1em;
            }
          }
          dd {
            border-radius: 100px;
            border: 2px solid;
            font-weight: bold;
            letter-spacing: 0.1em;
            @include media(pc) {
              padding: 8px 16px;
            }
            @include media(sp) {
              padding: 5px 12px;
            }
            &.is-result_pending {
              color: $yellow;
              border-color: $yellow;
            }
            &.is-unseated {
              color: #555;
              border-color: #dadada;
            }
            &.is-winning {
              color: $green;
              border-color: $green;
            }
          }
        }
      }
      .notice {
        margin-top: 10px;
        line-height: 1.6;
        color: $red;
        @include media(sp) {
          font-size: 12px;
        }
      }
    }
  }
  .eventdtl-related {
    border-top: 1px solid $dark_violet_border;
    background: #fff;
    @include media(sp) {
      position: relative;
      z-index: 11;
      padding-bottom: 30px;
    }
  }
}
</style>
